/**
 * Dropdown alignment
 *
 * Positions each desktop sub-menu so that:
 *   - top edge sits flush with the bottom of .navbar-one__desktop
 *   - left edge lines up with the first letter of the parent nav link
 *
 * Both values are relative to the parent .menu-item (position: relative).
 * Nested sub-menus are left to CSS (fly out to the right of their parent),
 * flipping to the left when there isn't room in the viewport.
 * Runs on load, once web fonts are ready, and on resize.
 */
(function () {
	var desktop = document.querySelector('.navbar-one__desktop');
	if (!desktop) return;

	function align() {
		var items = desktop.querySelectorAll('.navbar-one__menu-wrapper .menu-item-has-children');
		var desktopRect = desktop.getBoundingClientRect();

		items.forEach(function (item) {
			// Nested (3rd-level+) sub-menus fly out to the right of their parent via CSS
			if (item.parentElement.closest('.sub-menu')) {
				alignNested(item);
				return;
			}

			var link = item.querySelector(':scope > a');
			var submenu = item.querySelector(':scope > .sub-menu');
			if (!link || !submenu) return;

			var itemRect = item.getBoundingClientRect();
			var linkRect = link.getBoundingClientRect();
			var paddingLeft = parseFloat(window.getComputedStyle(link).paddingLeft) || 0;

			// top: flush with .navbar-one__desktop bottom edge
			var topOffset = desktopRect.bottom - itemRect.top;
			submenu.style.top = topOffset + 'px';

			// left: offset so submenu left aligns with first letter of parent link
			var left = (linkRect.left + paddingLeft) - itemRect.left;
			submenu.style.left = left + 'px';
		});
	}

	// Flip a nested sub-menu to open leftwards if it would overflow the viewport
	function alignNested(item) {
		var submenu = item.querySelector(':scope > .sub-menu');
		if (!submenu) return;

		item.classList.remove('sub-menu--flip');
		var itemRect = item.getBoundingClientRect();
		if (itemRect.right + submenu.offsetWidth > document.documentElement.clientWidth) {
			item.classList.add('sub-menu--flip');
		}
	}

	align();

	// Re-measure once web fonts load — nowrap labels widen the sub-menus
	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(align);
	}
	window.addEventListener('load', align);

	var timer;
	window.addEventListener('resize', function () {
		clearTimeout(timer);
		timer = setTimeout(align, 150);
	});
}());
